export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "total_number_producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productores"])},
          "total_hectares": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hectáreas"])},
          "new_producer_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuevo productor"])}
        }
      }
    }
  })
}